import { useEffect, useState } from "react";

const COLORS = ["#7C3AED", "#EC4899", "#F59E0B", "#10B981", "#3B82F6", "#EF4444"];

export function fireConfetti() {
  if (typeof window !== "undefined") window.dispatchEvent(new CustomEvent("slackr-confetti"));
}

export function GlobalConfetti() {
  const [burst, setBurst] = useState(null);
  useEffect(() => {
    const h = () => setBurst(Date.now());
    window.addEventListener("slackr-confetti", h);
    return () => window.removeEventListener("slackr-confetti", h);
  }, []);
  return <Confetti burstKey={burst} />;
}

export function Confetti({ burstKey }) {
  const [pieces, setPieces] = useState([]);
  useEffect(() => {
    if (burstKey == null) return;
    const arr = Array.from({ length: 80 }).map((_, i) => ({
      id: `${burstKey}-${i}`,
      left: Math.random() * 100,
      delay: Math.random() * 0.6,
      dur: 2.5 + Math.random() * 1.8,
      color: COLORS[i % COLORS.length],
      size: 8 + Math.random() * 8,
      rot: Math.random() * 360,
    }));
    setPieces(arr);
    const t = setTimeout(() => setPieces([]), 4800);
    return () => clearTimeout(t);
  }, [burstKey]);

  if (!pieces.length) return null;
  return (
    <div className="fixed inset-0 z-[90] pointer-events-none overflow-hidden" data-testid="kiosk-confetti">
      <style>{`@keyframes doeniesFall{0%{transform:translateY(-10vh) rotate(0);opacity:1}100%{transform:translateY(110vh) rotate(720deg);opacity:0.9}}`}</style>
      {pieces.map((p) => (
        <span key={p.id} style={{
          position: "absolute", top: 0, left: `${p.left}%`, width: p.size, height: p.size * 0.5,
          background: p.color, borderRadius: 2, transform: `rotate(${p.rot}deg)`,
          animation: `doeniesFall ${p.dur}s linear ${p.delay}s forwards`,
        }} />
      ))}
    </div>
  );
}
